import { AssetMaintenanceResolverBase } from './asset-maintenance.resolver.base';
import { AssetMaintenanceService } from './asset-maintenance.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class AssetMaintenanceResolver extends AssetMaintenanceResolverBase {

  constructor(protected service: AssetMaintenanceService) {
    super(service);
  }
}



